import moment from "moment";
import React, { useState } from "react";
import { ShortUrl } from "../../types/interfaces";
import {
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTd,
  StyledTh,
  StyledTr,
} from "./styled";
import { MdModeEditOutline, MdDelete, MdFileCopy } from "react-icons/md";
import { BiLinkExternal } from "react-icons/bi";
import { ImStatsDots } from "react-icons/im";
import { theme } from "../../theme";
import { GoCheck } from "react-icons/go";

interface Props {
  data: ShortUrl[];
  onEdit: (qr: ShortUrl) => void;
  onDelete: (qr: ShortUrl) => void;
}

const URLTable: React.FC<Props> = ({ data, onEdit, onDelete }) => {
  const [copied, setCopied] = useState("");
  return (
    <StyledTable>
      <StyledTableHead>
        <StyledTr>
          <StyledTh>Short URL</StyledTh>
          <StyledTh>Destination</StyledTh>
          <StyledTh>Clicks</StyledTh>
          <StyledTh>Created At</StyledTh>
          <StyledTh>Actions</StyledTh>
        </StyledTr>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row) => (
          <StyledTr key={row._id}>
            <StyledTd>
              <a
                rel="noreferrer"
                target="_blank"
                href={`${process.env.REACT_APP_HOST_DOMAIN}/${row.shortId}`}
              >
                {process.env.REACT_APP_HOST_DOMAIN}/{row.shortId}
                <BiLinkExternal />
              </a>
            </StyledTd>

            <StyledTd>{row.mainUrl}</StyledTd>
            <StyledTd className="clicks">
              <ImStatsDots />
              {row.clicks}
            </StyledTd>
            <StyledTd>{moment(row.createdAt).format("Do MMM, YYYY")}</StyledTd>
            <StyledTd>
              <MdModeEditOutline onClick={() => onEdit(row)} />
              <MdDelete onClick={() => onDelete(row)} />
              {copied !== row.shortId ? (
                <MdFileCopy
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${process.env.REACT_APP_HOST_DOMAIN}/${row.shortId}`
                    );
                    setCopied(row.shortId);
                  }}
                />
              ) : (
                <GoCheck
                  style={{
                    color: theme.textColor.primarySuccess,
                  }}
                />
              )}
            </StyledTd>
          </StyledTr>
        ))}
      </StyledTableBody>
    </StyledTable>
  );
};

export default URLTable;
